module.exports = __webpack_public_path__ + "static/img/007.55382f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/007.png
// module id = uUub
// module chunks = 1